import React, { Suspense, useEffect } from 'react';
import { Navigate, Route, Routes, useNavigate } from 'react-router';
import { setNavigator } from 'utils/navigation';
import woothee from 'woothee';

// dynamic import
const Survey = React.lazy(() => import(/* webpackChunkName: "Survey" */ 'containers/Survey'));
const Backend = React.lazy(() => import(/* webpackChunkName: "Backend" */ 'containers/Backend'));
const Completed = React.lazy(
  () => import(/* webpackChunkName: "Completed" */ 'components/common/Completed'),
);
const Closed = React.lazy(
  () => import(/* webpackChunkName: "Closed" */ 'components/common/Closed'),
);
const BaseNotFound = React.lazy(
  () => import(/* webpackChunkName: "BaseNotFound" */ 'components/common/NotFound'),
);

type Props = {
  isInitializedXCSRFToken: boolean;
  onRequestFetchXCSRFToken: () => void;
  setDeviceVariant: (userDevice: string) => void;
};

const App = (props: Props) => {
  const { isInitializedXCSRFToken, onRequestFetchXCSRFToken, setDeviceVariant } = props;
  const userAgent = woothee.parse(window.navigator.userAgent);
  const userDevice = userAgent.category;
  const navigate = useNavigate();

  // saga など React ツリー外から navigate を呼べるように登録する
  useEffect(() => {
    setNavigator(navigate);
  }, [navigate]);

  useEffect(() => {
    onRequestFetchXCSRFToken();
    setDeviceVariant(userDevice);
  }, []);

  if (!isInitializedXCSRFToken) return null;

  return (
    <Suspense fallback={null}>
      <Routes>
        <Route path='/surveys/:id' element={<Survey />} />
        <Route path='/admin/*' element={<Backend />} />
        <Route path='/backyard/*' element={<Backend />} />
        <Route path='/' element={<Navigate to='/admin/sign_in' replace />} />
        <Route path='/completed' element={<Completed />} />
        <Route path='/closed' element={<Closed />} />
        <Route path='*' element={<BaseNotFound />} />
      </Routes>
    </Suspense>
  );
};

export default App;
